import React from 'react';
import { Tabs } from 'antd';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import { Unit } from './Unit';
import { About } from '../../components/About';

export const Setting: React.FC = () => {
  
  return (
    <>
    <Tabs defaultActiveKey="1" tabPosition="left">
    <TabPane tab="机构设置" key="1">
      <Unit />
    </TabPane>
    <TabPane tab="关于" key="3">
      <About/>
    </TabPane>
  </Tabs>
    </>
  )
};